import './HomePage.css';
import InfoBoard from '../../InfoBoard/InfoBoard';
import { useState, useEffect } from 'react';
import { fetchInfoSingleData } from '../../../fetchFromDB';

export default function HomePage() {

	const [infoSingleDataArray, setInfoSingleDataArray] = useState([]);

	useEffect(() => {
		const loadData = async () => {
			try {
				const data = await fetchInfoSingleData();
				setInfoSingleDataArray(data);
			} catch (error) {
				console.error("Failed to load events", error);
			}
		};
		loadData();
	}, []);

	const filteredArray = infoSingleDataArray.filter(item => item.is_highlight);
	const recentDateSortArray = [...filteredArray].sort((a, b) => {
        return new Date(b.date) - new Date(a.date);
    });
	
	return (
		<div id='home-page'>
			<div id='feature'>
				<InfoBoard
					title="featureBanner"
					boardType='banner'
					boardCategory="featureBanner"
					showTextDetails={false}
					showTitle={false}
					cardCount={1}
					contentDataArray={recentDateSortArray}
				/>
			</div>
			<div id='highlight'>
				<InfoBoard
					title="Highlights"
					boardCategory="all"
					cardCount={3}
					contentDataArray={recentDateSortArray}
				/>
			</div>
		</div>
	);
}